<script>
import $ from 'domtastic';
import each from 'lodash/each';
import map from 'lodash/map';
import vueMixins from 'viralstyle-ui/src/vueMixins';
import LayoutHeader from 'sales-flow-ui/components/Header';
import Social from 'sales-flow-ui/components/SocialLinks';
import { mapState } from 'vuex';

import Logo from 'components/Logo';

class MenuLink {
  constructor(text, uri, showWhenUserLoggedIn, actionName, actionArgs, subMenu) {
    if (!text) {
      this.break = true;
    } else {
      this.text = text;
      this.uri = uri;
      this.showWhenUserLoggedIn = showWhenUserLoggedIn;
      this.actionName = actionName;
      this.actionArgs = actionArgs;
      this.subMenu = subMenu;
      this.subMenuOpen = false;
    }
  }
};

export default {
  components: {
    Logo,
    LayoutHeader,
    Social,
  },
  mixins: [vueMixins],
  data: () => ({
    prevSearch: null,
    currentScrollTop: 0,
    marketplaceCategories: null,
    menuLinks: null,
  }),
  computed: {
    ...mapState({
      cartStyle: state => state.cartStyle,
      userLoggedIn: state => state.userLoggedIn,
      currencyInfo: state => state.currencyInfo,
      processing: state => state.processing,
      cart: state => state.cart.cart,
      customer: state => state.checkout.customer,
      search: state => state.marketplace.search,
      searchApplied: state => state.marketplace.searchApplied,
      headerCollapsed: state => state.headerCollapsed,
      scrollingUp: state => state.scrollingUp,
      hideFixedHeader: state => state.hideFixedHeader,
      categories: state => state.marketplace.categories ? state.marketplace.categories.parent : null,
    }),
    isMobile() {
      return this.$mq === 'sm' || this.$mq === 'md';
    },
    isMobileSalesPage() {
      return this.$route.name === 'sales' && this.isMobile;
    },
  },
  watch: {
    categories(categories) {
      if (categories) {
        this.$_initMenuLinks();
      }
    },
  },
  created() {
    this.$_initMenuLinks();
  },
  mounted() {
    this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    $(window).on('scroll', this.$_handleScroll);
  },
  beforeDestroy() {
    $(window).off('scroll', this.$_handleScroll);
  },
  methods: {
    $_initMenuLinks() {
      let marketplaceCategories = map(this.categories, category => ({ text: category.category, value: category.id }));

      this.marketplaceCategories = [{ text: 'All', value: null }, ...marketplaceCategories];

      this.menuLinks = [
        new MenuLink('Shop', { name: 'marketplace' }, null, null, null, [
          ...this.marketplaceCategories,
        ]),
        new MenuLink(),
        new MenuLink('Start Selling', { name: 'openShop' }),
        new MenuLink('Track Order', { name: 'trackOrder' }),
        new MenuLink(),
        new MenuLink('Sign In', { name: 'signIn' }, false),
        new MenuLink('Sign Up', { name: 'signUp' }, false),
        new MenuLink('Dashboard', 'action', true, 'navigate', 'dashboard'),
        new MenuLink('Sign Out', 'action', true, 'log-out'),
      ];
    },
    async $_handleScroll() {
      let alreadyCollapsed = !this.headerCollapsed,
        fixedHeaderHidden = this.hideFixedHeader,
        alreadyScrollingUp = this.scrollingUp,
        searchInputs = document.querySelectorAll('.header-bottom__search input'),
        headerTop = document.querySelector('.header-top'),
        headerBottoms = document.querySelectorAll('.header-bottom');

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.updateState(this.$store.state, 'headerCollapsed', headerTop ? this.currentScrollTop > headerTop.clientHeight + 20 : false);

      let scrollingUp = this.currentScrollTop <= this.lastScrollTop;

      this.updateState(this.$store.state, 'scrollingUp', scrollingUp);

      if (this.isMobile) {
        this.updateState(this.$store.state, 'hideFixedHeader', this.currentScrollTop <= 0 ? true : alreadyScrollingUp && !fixedHeaderHidden ? false : this.currentScrollTop < 90 && scrollingUp);

        if (this.currentScrollTop === 0 && document.activeElement === searchInputs[1]) {
          searchInputs[0].focus();
        } else if (this.currentScrollTop > 0 && document.activeElement === searchInputs[0] && !this.hideFixedHeader) {
          searchInputs[1].focus();
        }
      } else {
        this.updateState(this.$store.state, 'hideFixedHeader', this.currentScrollTop < headerTop.clientHeight);

        await this.$nextTick();

        if (this.currentScrollTop < headerTop.clientHeight) {
          let focusedElement = headerBottoms[1].querySelector(':focus');

          if (focusedElement) {
            let fixedChildren = headerBottoms[1].getElementsByTagName('*'),
              staticChildren = headerBottoms[0].getElementsByTagName('*');

            each(fixedChildren, (child, index) => {
              if (child === document.activeElement) {
                staticChildren[index].focus();
              }
            })
          }

          if (this.$children[0].$refs.headerBottomFixed.showShopByMenu) {
            this.$children[0].$refs.headerBottomFixed.$_closeShopByMenu();
            this.$children[0].$refs.headerBottom.$refs.shopByMenu.click();
          }
        } else if (this.currentScrollTop > headerTop.clientHeight && !this.hideFixedHeader) {
          let focusedElement = headerBottoms[0].querySelector(':focus');

          if (focusedElement) {
            let fixedChildren = headerBottoms[1].getElementsByTagName('*'),
              staticChildren = headerBottoms[0].getElementsByTagName('*');

            each(staticChildren, (child, index) => {
              if (child === document.activeElement && fixedChildren[index].focus) {
                fixedChildren[index].focus();
              }
            })
          }

          if (this.$children[0].$refs.headerBottom.showShopByMenu) {
            this.$children[0].$refs.headerBottom.$_closeShopByMenu();
            this.$children[0].$refs.headerBottomFixed.$refs.shopByMenu.click();
          }
        }
      }

      this.lastScrollTop = this.currentScrollTop <= 0 ? 0 : this.currentScrollTop;
    },
    handleLogOut() {
      this.$store.dispatch('logout');
    },
    handleNavigation(route) {
      switch (route) {
        case 'dashboard':
          if (this.customer.role === 'CUSTOMER') {
            if (this.$route.name.indexOf('profile') === -1) {
              this.$router.push({ name: 'profile' });
            }
          } else {
            window.location = this.customer.dashboard_url;
          }
          break;
        case 'help':
          window.open('https://viralstyle.zendesk.com/hc/en-us');
          break;
        default:
          break;
      }
    },
    handleSearchInput(e) {
      this.$store.commit('updateState', { object: this.$store.state.marketplace, property: 'search', value: e.target.value });
    },
    performSearch(e) {
      this.handleSearchInput(e);

      if ((e.target.value || !e.target.value && this.searchApplied) && this.prevSearch !== e.target.value) {
        this.$store.dispatch('getMarketplaceCampaigns');

        this.$store.dispatch('eventSearch');
      }

      this.prevSearch = e.target.value;

      this.$store.commit('updateState', { object: this.$store.state.marketplace, property: 'searchApplied', value: !!e.target.value });
    },
  },
};
</script>

<template lang='pug'>
layout-header(
  cart-route='cart',
  checkout-route='checkout',
  :collapsed='headerCollapsed',
  :cart='cart',
  :user-logged-in='userLoggedIn',
  :processing='processing',
  :search='search',
  :marketplace-categories='marketplaceCategories',
  :customer='customer',
  :menu-links='menuLinks',
  :is-mobile='isMobile',
  :is-mobile-sales-page='isMobileSalesPage',
  :scrolling-up='scrollingUp',
  :hide-fixed-header='hideFixedHeader',
  :current-scroll-top='currentScrollTop',
  @navigate='handleNavigation',
  @log-out='handleLogOut',
  @search-input='handleSearchInput',
  @perform-search='performSearch',
)
  template(v-slot:logo='')
    router-link(:to='{ name: "home" }', aria-label='Home link')
      logo(header)

  template(v-slot:social='')
    social(menu)
</template>